import axios from 'axios'

import { customRequestHeader } from '@/locales'
import { getChannelId, getNationCode } from '@/utils/channel'
import { isDev } from '@/utils/config.js'
import { buildSignParams,generateSign } from '@/utils/sign'

// API 基础路径
const baseURL = isDev ? '/api' : ''

console.log('getChannelId, getNationCode', getChannelId(), getNationCode())

// 请求头常量
const DEFAULT_HEADERS = {
  channelId: getChannelId(),
  nationCode: getNationCode(),
  'Accept-Language': customRequestHeader['Accept-Language']
}

// 超时时间（毫秒）
const REQUEST_TIMEOUT = 20000

const service = axios.create({
  baseURL,
  headers: DEFAULT_HEADERS,
  timeout: REQUEST_TIMEOUT
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const dateTs = Date.now()
    const { data, headers, url } = config

    // 更新时间戳
    headers['ts'] = dateTs

    // 仅对 customer 相关接口添加签名
    if (url.includes('customer')) {
      // 构建签名参数并生成签名
      const signParams = buildSignParams(
        data || config.params,
        DEFAULT_HEADERS.nationCode,
        DEFAULT_HEADERS.channelId,
        dateTs
      )
      headers['sign'] = generateSign(signParams)
    }

    return config
  },
  error => {
    console.error('[Request Error]', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    }
    return Promise.reject(response.data)
  },
  error => {
    console.error('[Response Error]', error)
    return Promise.reject(error)
  }
)

export default service